import {
  faClipboardCheck,
  faPaperPlane,
  faPlus,
  faRankingStar
} from '@fortawesome/pro-solid-svg-icons'
import type { ApplicantHistoryEvent } from '~/domains/actions/types'
import { ShortlistApplicantFeedback } from '~/domains/orders/components/ShortlistApplicantFeedback'
import { ShortlistReportButton } from '~/domains/orders/components/ShortlistReportButton'
import {
  AvailabilityUpdateHistoryCard,
  BaseHistoryCard,
  CallHistoryCard,
  EmailHistoryCard,
  MeetingHistoryCard,
  NotesHistoryCard,
  SmsHistoryCard,
  StatusUpdateHistoryCard,
  TaskHistoryCard
} from './index'

const profileCount = (applicants?: string[]): string => {
  const count = applicants?.length ?? 0
  return `${count} profil${count > 1 ? 's' : ''}`
}

export const HistoryEventCard = ({
  event
}: {
  event: ApplicantHistoryEvent
}) => {
  switch (event.type) {
    case 'recall':
    case 'recall_schedule':
      return <CallHistoryCard event={event} />
    case 'meeting_schedule':
    case 'meeting_applicant':
    case 'meeting_contact':
      return <MeetingHistoryCard event={event} />
    case 'send_email':
    case 'email_received':
      return <EmailHistoryCard event={event} />
    case 'sms_sent':
    case 'sms_received':
      return <SmsHistoryCard event={event} />
    case 'status_update':
      return <StatusUpdateHistoryCard event={event} />
    case 'notes':
      return <NotesHistoryCard event={event} />
    case 'availability_update':
      return <AvailabilityUpdateHistoryCard event={event} />
    case 'task':
      return <TaskHistoryCard event={event} />
    case 'create_order':
      return (
        <BaseHistoryCard
          event={event}
          icon={faPlus}
          title="Création de la commande"
        />
      )
    case 'test_sent':
      return (
        <BaseHistoryCard
          event={event}
          icon={faPaperPlane}
          title="Test envoyé"
        />
      )
    case 'test_completed':
      return (
        <BaseHistoryCard
          event={event}
          icon={faClipboardCheck}
          title={
            event.notes ? `Test complété : ${event.notes}` : 'Test complété'
          }
        />
      )
    case 'shortlist_submitted':
      return event.shortlistFeedback ? (
        <BaseHistoryCard
          event={event}
          icon={faRankingStar}
          title="Retour du contact sur ce profil"
        >
          <ShortlistApplicantFeedback feedback={event.shortlistFeedback} />
        </BaseHistoryCard>
      ) : (
        <BaseHistoryCard
          event={event}
          icon={faRankingStar}
          title={`Le contact a classé ${profileCount(event.applicants)}`}
          headerAction={
            event.shortlistId ? (
              <ShortlistReportButton shortlistId={event.shortlistId} />
            ) : null
          }
        />
      )
  }
}
